import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { observer } from "mobx-react-lite";
import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as HideIcon } from "../../assets/icons/expand-less.svg";
import { ReactComponent as ShowIcon } from "../../assets/icons/expand-more.svg";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import { i18nConfig } from "../../i18nConfig";
/**
 * Renders a facet title & the button to show/hide facet options.
 * @param titleKey facet title key, used to get translation
 */
export const FacetTitle = observer(({ titleKey }) => {
    const uiStore = useContext(UIStateStoreContext);
    const facetValue = uiStore.getAvailableFacets()?.find((value) => value.label === titleKey)?.field;
    const isOpen = !!facetValue && uiStore.isFacetOpen(facetValue);
    function toggleShowOptions() {
        if (facetValue) {
            isOpen
                ? uiStore.setFacetState(facetValue, false)
                : uiStore.setFacetState(facetValue, true);
        }
    }
    function handleKeyDown(event) {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            toggleShowOptions();
        }
    }
    return (_jsxs("div", { className: "facet-title", "data-testid": `facet-title-${useIntl().formatMessage({ id: titleKey })}`, tabIndex: 0, "aria-label": "Open/close facet: " + useIntl().formatMessage({ id: titleKey }), "aria-expanded": isOpen, onKeyDown: handleKeyDown, onClick: toggleShowOptions, children: [_jsx("h3", { children: _jsx(FormattedMessage, { id: titleKey, defaultMessage: i18nConfig.messages[i18nConfig.defaultLocale][titleKey] }) }), isOpen ? (_jsx(HideIcon, { "aria-label": useIntl().formatMessage({ id: "icon.hide.title" }), "data-testid": "hideOptionsIcon" })) : (_jsx(ShowIcon, { "aria-label": useIntl().formatMessage({ id: "icon.show.title" }), "data-testid": "showOptionsIcon" }))] }));
});
